import './PrivacyPolicy.css'
interface IPrivacyPolicy{
  showContact?:boolean;
}
export const PrivacyPolicy = ({showContact}:IPrivacyPolicy) => {
  return (
    <div className="privacy-policy-main">
      
      
      {/* Hero Section */}
      <section className="privacy-policy-hero-section">
        <div className="absolute-inset-0-bg-black-10"></div>
        <div className="relative-max-w-4xl-mx-auto-px-4-sm-px-6-lg-px-8-text-center">
          <h1 className="text-4xl-md-text-5xl-font-bold-text-white-mb-4">
            Integritetspolicy
          </h1>
          <p className="text-xl-text-white-90">
            Sandra's Hälsa – Din integritet är viktig för oss
          </p>
        </div>
      </section>

      <main className="max-w-4xl-mx-auto-px-4-sm-px-6-lg-px-8-py-16">
        <div className="bg-card-rounded-2xl-shadow-lg-p-8-md-p-12">
          <div className="space-y-8">
            <div className="text-center-mb-12">
              <p className="text-sm-text-muted-foreground-bg-muted-50-rounded-full-px-4-py-2-inline-block">
                <strong>Senast uppdaterad:</strong> 2025-09-02
              </p>
            </div>

            <div className="prose-prose-lg-max-w-none">
              <p className="text-lg-text-muted-foreground-leading-relaxed">
                Vi på Sandra's Hälsa värnar om din integritet och behandlar alltid dina personuppgifter i enlighet med gällande dataskyddslagstiftning (GDPR – EU:s allmänna dataskyddsförordning). Denna policy förklarar hur vi samlar in, använder och skyddar dina personuppgifter.
              </p>
            </div>

            <div className="bg-gradient-to-r-from-f39e60-10-to-e16a54-10-rounded-xl-p-6-border-l-4-border-f39e60">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-f39e60-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">1</span>
                Personuppgifter vi samlar in
              </h2>
              <p className="text-muted-foreground-mb-4">
                Vi kan samla in följande uppgifter när du använder våra tjänster eller kontaktar oss:
              </p>
              <ul className="space-y-3">
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Namn och kontaktuppgifter (e-postadress, telefonnummer)</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Betalnings- och faktureringsinformation</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Hälsorelaterade uppgifter som du själv väljer att dela vid rådgivning, coaching eller 1:1-sessioner</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-e16a54-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Tekniska data (IP-adress, webbläsare, cookies) när du besöker vår webbplats</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-r-from-e16a54-10-to-7c444f-10-rounded-xl-p-6-border-l-4-border-e16a54">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-e16a54-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">2</span>
                Syfte med behandlingen
              </h2>
              <p className="text-muted-foreground-mb-4">
                Vi behandlar dina personuppgifter för att:
              </p>
              <ul className="space-y-3">
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Leverera de tjänster och produkter du beställer</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Skicka bokningsbekräftelser, kvitton och annan nödvändig information (transaktionella mejl)</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Hantera medlemskap, kurser och kundkonton</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Skicka nyhetsbrev och marknadsföringsinformation till dig som aktivt samtyckt</span>
                </li>
                <li className="flex-items-start">
                  <span className="w-2-h-2-bg-f39e60-rounded-full-mt-2-mr-3-flex-shrink-0"></span>
                  <span className="text-foreground">Förbättra vår hemsida och våra tjänster</span>
                </li>
              </ul>
            </div>

            <div className="bg-gradient-to-r-from-7c444f-10-to-f39e60-10-rounded-xl-p-6-border-l-4-border-7c444f">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-7c444f-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">3</span>
                Rättslig grund
              </h2>
              <p className="text-muted-foreground-mb-4 ">
                Behandlingen av dina uppgifter baseras på:
              </p>
              <div className="grid-grid-cols-1-md-grid-cols-2-gap-4">
                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h4 className="font-semibold-text-7c444f-mb-2">Avtal</h4>
                  <p className="text-sm-text-muted-foreground">För att kunna tillhandahålla de tjänster du beställt</p>
                </div>
                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h4 className="font-semibold-text-e16a54-mb-2">Samtycke</h4>
                  <p className="text-sm-text-muted-foreground">För nyhetsbrev och marknadsföringsutskick</p>
                </div>
                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h4 className="font-semibold-text-f39e60-mb-2">Rättslig förpliktelse</h4>
                  <p className="text-sm-text-muted-foreground">För bokföringsändamål och annan lagstadgad hantering</p>
                </div>
                <div className="bg-white-50-rounded-lg-p-4-border-border-muted">
                  <h4 className="font-semibold-text-7c444f-mb-2">Berättigat intresse</h4>
                  <p className="text-sm-text-muted-foreground">För att utveckla och förbättra våra tjänster</p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r-from-f39e60-5-to-e16a54-5-rounded-xl-p-6">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-gradient-to-r-from-f39e60-to-e16a54-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">4</span>
                Lagring av uppgifter
              </h2>
              <p className="text-muted-foreground-leading-relaxed">
                Vi sparar dina uppgifter endast så länge som är nödvändigt för att uppfylla syftet med behandlingen, eller så länge lagen kräver.
              </p>
            </div>

            <div className="bg-gradient-to-r-from-e16a54-5-to-7c444f-5-rounded-xl-p-6">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-gradient-to-r-from-e16a54-to-7c444f-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">5</span>
                Delning av uppgifter
              </h2>
              <p className="text-muted-foreground-leading-relaxed">
                Vi delar aldrig dina personuppgifter med tredje part för marknadsföringsändamål. Vi kan dock dela uppgifter med pålitliga leverantörer som hjälper oss att leverera våra tjänster, t.ex. betalningslösningar eller e-postplattformar. Alla leverantörer omfattas av avtal enligt GDPR.
              </p>
            </div>

            <div className="bg-gradient-to-r-from-7c444f-10-to-f39e60-10-rounded-xl-p-6-border-l-4-border-7c444f">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-7c444f-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">6</span>
                Dina rättigheter
              </h2>
              <p className="text-muted-foreground-mb-4">
                Du har rätt att:
              </p>
              <div className="grid-grid-cols-1-md-grid-cols-2-gap-3">
                <div className="flex-items-center-bg-white-50-rounded-lg-p-3">
                  <div className="w-3-h-3-bg-f39e60-rounded-full-mr-3"></div>
                  <span className="text-sm-text-foreground">Begära utdrag av dina personuppgifter</span>
                </div>
                <div className="flex-items-center-bg-white-50-rounded-lg-p-3">
                  <div className="w-3-h-3-bg-e16a54-rounded-full-mr-3"></div>
                  <span className="text-sm-text-foreground">Begära rättelse av felaktiga uppgifter</span>
                </div>
                <div className="flex-items-center-bg-white-50-rounded-lg-p-3">
                  <div className="w-3-h-3-bg-7c444f-rounded-full-mr-3"></div>
                  <span className="text-sm-text-foreground">Begära radering av dina uppgifter</span>
                </div>
                <div className="flex-items-center-bg-white-50-rounded-lg-p-3">
                  <div className="w-3-h-3-bg-f39e60-rounded-full-mr-3"></div>
                  <span className="text-sm-text-foreground">Återkalla samtycke för nyhetsbrev</span>
                </div>
                <div className="flex items-center bg-white/50 rounded-lg p-3 md:col-span-2">
                  <div className="w-3 h-3 bg-[#E16A54] rounded-full mr-3"></div>
                  <span className="text-sm-text-foreground">Lämna klagomål till Integritetsskyddsmyndigheten (IMY)</span>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-r-from-f39e60-5-to-e16a54-5-rounded-xl-p-6">
              <h2 className="text-2xl-font-bold-text-foreground-mb-4-flex-items-center">
                <span className="bg-gradient-to-r-from-f39e60-to-e16a54-text-white-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">7</span>
                Cookies
              </h2>
              <p className="text-muted-foreground-leading-relaxed">
                Vår webbplats använder cookies för att förbättra användarupplevelsen och analysera trafik. Du kan hantera eller stänga av cookies i din webbläsares inställningar.
              </p>
            </div>
          {typeof showContact === 'undefined' && 
            <div className="bg-gradient-to-r-from-e16a54-to-7c444f-rounded-xl-p-8-text-white">
              <h2 className="text-2xl-font-bold-mb-4-flex-items-center">
                <span className="bg-white-20-backdrop-blur-sm-rounded-full-w-8-h-8-flex-items-center-justify-center-text-sm-mr-3">8</span>
                Kontakt
              </h2>
              <p className="mb-6-text-white-90">
                Om du har frågor om denna integritetspolicy eller vår behandling av dina personuppgifter är du välkommen att kontakta oss:
              </p>
              <div className="bg-white-10-backdrop-blur-sm-rounded-lg-p-6-border-border-white-20">
                <h3 className="font-bold-text-f39e60-text-lg-mb-2">Sandra's Hälsa</h3>
                <p className="text-white-90">E-post: info@sandrashalsa.se</p>
              </div>
            </div>
          }
            
          </div>
        </div>
      </main>
      
    </div>
  );
};